import { Component, computed, effect, inject, input } from '@angular/core';
import { FieldTree, FormField } from '@angular/forms/signals';
import { MatSelectModule } from '@angular/material/select';
import { MceApiService } from '../../../../core/mceapi.client.generated';
import { EditCable } from '../../cable-edit.model';
import { SpacingComponent } from '../spacing/spacing.component';
import { SCA, singleCoreCases } from './single-core-arrangement.model';
import { rxResource } from '@angular/core/rxjs-interop';
import { createSystemVoltageDto } from '../../system-voltage/system-voltage.model';
import { BS7671_STANDARD_GUID, ERA6930P3_STANDARD_GUID, ERA6930P5_STANDARD_GUID, IEC60502P2_STANDARD_GUID, UDR_STANDARD_GUID } from '../../../../shared/constants';
import { map, of } from 'rxjs';

@Component({
  selector: 'app-single-core-arrangement',
  imports: [FormField,MatSelectModule,SpacingComponent],
  templateUrl: './single-core-arrangement.component.html',
  styles: ``,
})
export class SingleCoreArrangementComponent {

  protected readonly sca = SCA;

  readonly form = input.required<FieldTree<EditCable>>();

  private mceApiService = inject(MceApiService);

    secondaryMethodGuid = computed(() => {
      switch(this.form().installation.standardGuid().value()) {
        case BS7671_STANDARD_GUID: return this.form().installation.bs7671Factors.secondaryMethodGuid().value();
        case ERA6930P3_STANDARD_GUID: return this.form().installation.era6930P3Factors.secondaryMethodGuid().value();
        case ERA6930P5_STANDARD_GUID: return this.form().installation.era6930P5Factors.secondaryMethodGuid().value();
        case IEC60502P2_STANDARD_GUID: return this.form().installation.iec60502Factors.secondaryMethodGuid().value();
        case UDR_STANDARD_GUID: return undefined;
        default: return undefined;
        }
  })

  secondaryMethodValidCasesRx = rxResource({
    params: () => {
      const secondaryMethodGuid = this.secondaryMethodGuid();

      return {
        systemVoltage: createSystemVoltageDto(this.form().systemVoltage)(),
        voltageCase: this.form().systemVoltage.case().value(),
        libraryGuid: this.form().selectedCable.libraryGuid().value(),
        secondaryMethodGuid,
        valid:
          this.form().systemVoltage().valid() && this.form().selectedCable().valid()
          && typeof secondaryMethodGuid === 'string' && secondaryMethodGuid.trim().length > 0
      };
    },
    stream: ({ params }) =>
      params.valid && params.secondaryMethodGuid !== undefined
        ? this.mceApiService.v1CableInstallationSingleCoreArrangement(
          params.libraryGuid, params.secondaryMethodGuid, params.systemVoltage).pipe(
            map(response => response
              .map(x => x.case)
              .filter((value): value is string => value !== undefined)))
        : of(singleCoreCases(params.voltageCase).map(x => x.value))
  });
  secondaryMethodValidCases = computed(() => this.secondaryMethodValidCasesRx.value() ?? []);


  cases = computed(() => {
    const type = this.form().systemVoltage.case().value();
    return singleCoreCases(type).filter(x => this.secondaryMethodValidCases().includes(x.value));
  });

  resetCase = effect(() => {

    const validCases = this.cases();


    const currentCase = this.form().installation.singleCoreArrangement.case();

    if (validCases.length >0 && validCases.findIndex(x => x.value === currentCase.value()) === -1) {
      currentCase.value.set(validCases[0].value);
    }
  });

}
